import { cx } from '@platform/core/lib/cx';
import { Icon } from './Icon';
import type { IButtonProps } from './IButtonProps';

/**
 * Кнопка v4: 34px (sm 30, xs 28), радіус 8px, підпис 600; наведення — рамка акценту, вимкнена — прозорість 0.5 без наведення.
 * Варіанти: default · primary · danger · ghost · dashed; icon — квадратна; startIcon — іконка Lucide перед підписом.
 */
export function Button({ variant = 'default', size = 'md', icon, startIcon, className, type = 'button', children, ...rest }: IButtonProps) {
  return (
    <button
      type={type}
      className={cx('btn', variant !== 'default' && `btn--${variant}`, size !== 'md' && `btn--${size}`, icon && 'btn--icon', className)}
      {...rest}
    >
      {startIcon && <Icon name={startIcon} size={size === 'md' ? 16 : 15} />}
      {children}
    </button>
  );
}
